<template>
  <div class="main-container">
    <page-header>{{'大会日程' | dealLanguage('Conference Agenda')}}</page-header>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="main-content">
      <div class="first-froum" @click="handleClick(0)">
        <div class="froum-title">
          <span>{{froum_list[0]['activityName'] | dealLanguage(froum_list[0]['enActivityName'])}}</span>
        </div>
      </div>
      <div class="froum-list">
        <div class="froum-li" v-for="(item, index) in froum_list.slice(1)" :key="index" @click="handleClick(index + 1)">
          <div class="froum-title">{{ item.activityName | dealLanguage(item.enActivityName)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import { getAgendaList } from '@/service/vbef'
import filter from 'js/filter'

export default {
  metaInfo() {
    return {
      title: '大会日程',
    }
  },
  inject: ['globalInsertRecords'],
  metaInfo() {
    return {
      title: '大会日程',
    }
  },
  data() {
    return {
      froum_list: [],
      loading: false,
      currentActivityId: '',
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  created() {},
  mounted() {
    this.currentActivityId = this.$route.query.actId || this.activityId
    this.getAgendaList()
  },
  methods: {
    async getAgendaList() {
      this.loading = true
      let res = await getAgendaList({
        actId: this.currentActivityId,
        assortName: '',
        dateName: '',
      })
      this.loading = false
      if (res.code == 0) {
        this.$set(this.$data, 'froum_list', res.data.activities)
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleClick(index) {
      this.$router.push({
        path: '/agenda#froum' + index,
        query: {
          actId: this.currentActivityId,
        },
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
.main-container
  position relative
  .main-content
    padding 40px 0
    .first-froum
      background-image url('~pic/theme-bg.png')
      background-repeat no-repeat
      background-size 100% 100%
      height 160px
      display flex
      align-items center
      cursor pointer
      .froum-title
        width 100%
        height 80px
        background linear-gradient(90deg, rgba(255, 167, 98, 0.6) 0%, #FF7000 53%, rgba(255, 167, 98, 0.6) 100%)
        padding 0 40px
        font-weight 400
        font-size 28px
        color #FFFFFF
        line-height 1.5
        display flex
        align-items center
        justify-content center
  .froum-list
    display grid
    grid-template-columns repeat(5, 1fr)
    grid-auto-rows 160px
    .froum-li
      // background-image url('~pic/theme-icon.png')
      // background-repeat no-repeat
      // background-size 89px 86px
      // background-position right bottom
      border 1px solid #ED6D01
      padding 15px
      display flex
      align-items center
      cursor pointer
      transition: all .3s ease-in-out
      &:hover
        background-color: #FFE8D9
      &:nth-child(n+6)
        border-top 0
      &:not(:nth-child(5n+1))
        border-left 0
      .froum-title
        width 100%
        font-weight 400
        font-size 16px
        color #C7000C
        line-height 26px
</style>